import type { PaymentStatus } from '@/types/billing';

export const queryKeys = {
  billing: ['billing'] as const,
  usage: (period: string, organizationId?: string) =>
    ['billing', 'usage', period, organizationId] as const,
  paymentHistory: (
    startPeriod: string,
    endPeriod: string,
    paymentStatus?: PaymentStatus,
    page?: number,
    size?: number
  ) =>
    [
      'billing',
      'paymentHistory',
      startPeriod,
      endPeriod,
      paymentStatus,
      page,
      size,
    ] as const,
  receipt: (paymentNo: string) => ['billing', 'receipt', paymentNo] as const,
};
